import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { userInformationService } from "../../_services/userInformation.service";

export function UserAddressView() {

    const { userId } = useParams<{ userId: string }>();

    let navigate = useNavigate();

    const resetData = () => ({
        id: "",
        firstName: '',
        lastName: '',
        name: '',
        email: '',
        phone: '',
        country: '',
        address: '',
        county: '',
        postalCode: '',
        username: '',
        userId: userId
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState<any>(resetData);

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
    }, []);

    function fetchData(id: string) {

        setIsLoading(true)
        return userInformationService
            .getAddressInformation(id)
            .then(
                (json) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function handleChange(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: event.target.value } });
    };


    return (

        <ValidatorForm
            onSubmit={() => { }}
            noValidate>

            <Grid container spacing={2} sx={{ mt: 0 }}>

                <Grid item xs={12}>
                    <Typography variant="h6" textAlign="center">Address Details</Typography>
                </Grid>


                <Grid item xs={12}>
                    <TextValidatorHcs
                        key="address"
                        name="address"
                        label="Address"
                        fullWidth
                        required
                        withRequiredValidator
                        validators={['required']}
                        errorMessages={['Address is required.']}
                        value={data.address}
                        onChange={handleChange}
                        multiline
                        rows={3}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextValidatorHcs
                        key="county"
                        name="county"
                        label="County"
                        fullWidth
                        required
                        withRequiredValidator
                        validators={['required']}
                        errorMessages={['County is required.']}
                        value={data.county}
                        onChange={handleChange}
                    />
                </Grid>


                <Grid item xs={12} md={6}>
                    <TextValidatorHcs
                        key="postalCode"
                        name="postalCode"
                        label="Postal Code"
                        fullWidth
                        required
                        validators={['required', 'minStringLength:4', 'maxStringLength:10']}
                        errorMessages={['Postal Code is required.', "Postal code must be at least 4 characters long.", "Postal code should not exceed 10 characters."]}
                        value={data.postalCode}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidatorHcs
                        key="city"
                        name="city"
                        label="City"
                        fullWidth
                        required
                        withRequiredValidator
                        validators={['required']}
                        errorMessages={['City is required.']}
                        value={data.city}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidatorHcs
                        key="country"
                        name="country"
                        label="Country"
                        fullWidth
                        required
                        withRequiredValidator
                        validators={['required']}
                        errorMessages={['County is required.']}
                        value={data.country}
                        onChange={handleChange}
                    />
                </Grid>

            </Grid>

        </ValidatorForm >

    );

}
